// extracted by mini-css-extract-plugin
module.exports = {"navIcon":"BackArrowIcon_navIcon__7GFOf"};